<template>
  <div class="nft-pagination">
    <button
      type="button"
      :class="{ disabled }"
      @click="handleCurrentChange(currentPage > 1 ? currentPage - 1 : 1)"
    >
      <i class="prev">
        <svg
          width="16"
          height="16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M10.174 2.076a.6.6 0 010 .848L5.1 8l5.075 5.076a.6.6 0 01-.848.848L4.06 8.66a.933.933 0 010-1.32l5.265-5.264a.6.6 0 01.848 0z"
            fill="#18191C"
          />
        </svg>
      </i>
    </button>
    <ul class="nft-pager">
      <li
        :class="{ active: currentPage === 1, disabled }"
        @click="handleCurrentChange(1)"
      >
        1
      </li>
      <li :class="{ disabled }" v-if="showPrevMore">...</li>
      <li
        v-for="pager in pagers"
        :key="pager"
        :class="{ active: currentPage === pager, disabled }"
        @click="handleCurrentChange(pager)"
      >
        {{ pager }}
      </li>
      <li :class="{ disabled }" v-if="showNextMore">...</li>
      <li
        :class="{ active: currentPage === pageCount, disabled }"
        @click="handleCurrentChange(pageCount)"
      >
        {{ pageCount }}
      </li>
    </ul>
    <button
      type="button"
      :class="{ disabled }"
      @click="
        handleCurrentChange(
          currentPage < pageCount ? currentPage + 1 : pageCount
        )
      "
    >
      <i class="next">
        <svg
          width="16"
          height="16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M5.826 2.076a.6.6 0 000 .848L10.9 8l-5.075 5.076a.6.6 0 00.848.848l5.264-5.264a.933.933 0 000-1.32L6.674 2.076a.6.6 0 00-.848 0z"
            fill="#61666D"
          />
        </svg>
      </i>
    </button>
  </div>
</template>

<script>
export default {
  name: "NftPagination",
  components: {},
  props: {
    currentPage: Number,
    pageTotal: Number,
    pageSize: Number,
    pagerCount: Number,
    disabled: Boolean,
  },
  data() {
    return {};
  },
  computed: {
    pageCount() {
      return Math.max(1, Math.ceil(this.pageTotal / this.pageSize));
    },
    halfPagerCount() {
      const pagerCount = this.pagerCount;
      const halfPagerCount = (pagerCount - 1) / 2;
      return halfPagerCount;
    },
    showPrevMore() {
      const pagerCount = this.pagerCount;

      const currentPage = Number(this.currentPage);
      const pageCount = Number(this.pageCount);

      if (pageCount > pagerCount) {
        if (currentPage > pagerCount - this.halfPagerCount) {
          return true;
        }
      }
      return false;
    },
    showNextMore() {
      const pagerCount = this.pagerCount;

      const currentPage = Number(this.currentPage);
      const pageCount = Number(this.pageCount);

      if (pageCount > pagerCount) {
        if (currentPage < pageCount - this.halfPagerCount) {
          return true;
        }
      }
      return false;
    },
    pagers() {
      const pagerCount = this.pagerCount;

      const currentPage = Number(this.currentPage);
      const pageCount = Number(this.pageCount);

      let showPrevMore = this.showPrevMore;
      let showNextMore = this.showNextMore;

      const array = [];

      if (showPrevMore && !showNextMore) {
        const startPage = pageCount - (pagerCount - 2);
        for (let i = startPage; i < pageCount; i++) {
          array.push(i);
        }
      } else if (!showPrevMore && showNextMore) {
        for (let i = 2; i < pagerCount; i++) {
          array.push(i);
        }
      } else if (showPrevMore && showNextMore) {
        const offset = Math.floor(pagerCount / 2) - 1;
        for (let i = currentPage - offset; i <= currentPage + offset; i++) {
          array.push(i);
        }
      } else {
        for (let i = 2; i < pageCount; i++) {
          array.push(i);
        }
      }
      return array;
    },
  },
  methods: {
    handleCurrentChange(val) {
      if (this.disabled) {
        return;
      }
      this.$emit("change", val);
    },
  },
};
</script>

<style lang="scss">
.nft-pagination {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: white;
  font-size: 14px;
  color: black;
  .nft-pager {
    flex-grow: 1;
    display: flex;
    flex-direction: row;
    justify-content: space-evenly;
    align-items: center;
    height: 44px;
    li {
      box-sizing: border-box;
      padding: 8px;
      &.active,
      &:not(.disabled):active {
        font-weight: 500;
        color: white;
        background-color: #ff6699;
        padding: 4px 8px;
        margin: 4px 0;
        border-radius: 4px;
      }
    }
  }
  button {
    width: 36px;
    border: none;
    background: transparent;
    i {
      display: block;
      padding: 2px;
      border-radius: 4px;
      &.next {
        float: left;
      }
      &.prev {
        float: right;
      }
    }
    &:not(.disabled):active {
      i {
        background-color: #ff6699;
      }
      svg {
        path {
          fill: white;
        }
      }
    }
  }
}
</style>
